import {useContext} from "react";
import {TelephoneAuthenticationContext} from "../context/TelephoneAuthenticationContext";

export const useTelephoneAuthentication = () => {
  return useContext(TelephoneAuthenticationContext)
}